export default class UserActivity {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/userActivity";
  }

  postNonClobUserActivity(userActivityDto) {
    return this.client.post(this.resourceUrl, {
      savedActivities: userActivityDto,
    });
  }

  postClobUserActivity(userActivityDtoArray) {
    return this.client.post(`${this.resourceUrl}/clob`, userActivityDtoArray);
  }

  getLoginActivity(userID) {
    return this.client.get(`${this.resourceUrl}/login`);
  }
}
